const prefersReducedMotion = () => {
  if (typeof window === 'undefined') return false;

  const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  // Check if the media query matches or is not available.
  return (!mediaQuery || mediaQuery.matches);
};

export default prefersReducedMotion;
